import {LangKeyType} from '../../../../../../../provider/locale/translation/type';

export enum CategoryFromGalleryFormItemEnum {
    All = 'all',
    Video = 'video',
}

export const categoryFromGalleryList: Array<{key: CategoryFromGalleryFormItemEnum; label: LangKeyType}> = [
    {key: CategoryFromGalleryFormItemEnum.All, label: 'TAGS__TAG_TYPE__ALL'},
    {key: CategoryFromGalleryFormItemEnum.Video, label: 'POSTS_FORM__VIDEO'},
];
